var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPollParticipation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9977 6.52539C23.9977 8.85273 22.1062 10.7441 19.7789 10.7441H4.21875C1.89141 10.7441 0 8.85273 0 6.52539C0 4.19805 1.89141 2.30664 4.21875 2.30664H19.7789C22.1133 2.30664 23.9977 4.19102 23.9977 6.52539Z",
    fill: "#00528C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36 18C36 20.3273 34.1086 22.2188 31.7812 22.2188H4.21875C1.89141 22.2188 0 20.3273 0 18C0 15.6727 1.89141 13.7812 4.21875 13.7812H31.7812C34.1086 13.7812 36 15.6727 36 18Z",
    fill: "#41A5EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0023 29.4756C12.0023 31.8029 10.1109 33.6943 7.78359 33.6943H4.21875C1.89141 33.6943 0 31.8029 0 29.4756C0 27.1482 1.89141 25.2568 4.21875 25.2568H7.78359C10.1109 25.2568 12.0023 27.1482 12.0023 29.4756Z",
    fill: "#0077CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollParticipation);
export default __webpack_public_path__ + "static/media/poll_participation.b6a32a4aa3c58bf21123f947ff8ec41e.svg";
export { ForwardRef as ReactComponent };